import { EntityNames, SortingInput } from 'src/graphql/types';

// Hard-coded GraphQL `sorting` for the compact mini-search pane (server-side only).
const NEWEST_FIRST: SortingInput[] = [
  { attribute: 'updatedAt', desc: true },
  { attribute: 'createdAt', desc: true },
];

export const MINI_SEARCH_SORTING: Partial<Record<EntityNames, SortingInput[]>> = {
  [EntityNames.Conversation]: [
    // open/new statuses first (same path Recent Conversations uses)
    { attribute: 'status/sortOrder', desc: false },
    { attribute: 'lastMessageReceivedAt', desc: true },
    { attribute: 'createdAt', desc: true },
  ],
  [EntityNames.Site]: NEWEST_FIRST,
  [EntityNames.Client]: NEWEST_FIRST,
  [EntityNames.Project]: NEWEST_FIRST,
};
